import { combineReducers } from 'redux';
import {
  CHANGE_SETTINGS,
  OPEN_MENU,
  REFRESH,
  SETTINGS_OPEN,
  PUSH_CURRENT,
  OPEN_INFO,
  OPEN_CLOSE_FILE,
  OPEN_TERMINAL,
  FIRE_COMMAND,
} from '../Utils/redux_actions';
import { commands_list, desktop_directories } from '../Utils/constants';
import { loginReducer } from './loginReducer';

const INITIAL_STATE = {
  info_show: false,
  desktop: {
    folders: desktop_directories,
  },
  menu: {
    show: false,
    terminal: false,
  },
  settings: {
    show: false,
    localization: {
      date: new Date(),
      date_format: 'DD/MM/YYYY',
      time_format: 'hh:mm A',
    },
    network: {
      status: navigator.onLine,
    },
  },
  current: {
    type: null,
    header: null,
    files: [],
    show: false,
  },
  file: {
    show: false,
    data: null,
  },
  terminal: {
    history: [],
    command: `[use:> ${commands_list.ls_cmd}] for command list`,
    prompt: '',
    current: '/',
  },
};

const pageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OPEN_MENU: {
      return {
        ...state,
        menu: {
          ...state.menu,
          show: !state.menu.show,
        },
      };
    }
    case OPEN_TERMINAL: {
      return {
        ...state,
        menu: {
          ...state.menu,
          terminal: !state.menu.terminal,
        },
      };
    }
    case OPEN_INFO: {
      return {
        ...state,
        info_show: !state.info_show,
        info: action.data,
      };
    }
    case REFRESH: {
      return INITIAL_STATE;
    }
    case SETTINGS_OPEN: {
      return {
        ...state,
        menu: {
          ...state.menu,
          show: false,
        },
        settings: {
          ...state.settings,
          show: action.open,
        },
      };
    }
    case CHANGE_SETTINGS: {
      return {
        ...state,
        settings: action.settings,
      };
    }
    case PUSH_CURRENT: {
      return action.show
        ? {
            ...state,
            menu: {
              ...state.menu,
              show: false,
            },
            settings: {
              ...state.settings,
              show: false,
            },
            current: action.current,
          }
        : {
            ...state,
            current: {
              ...state.current,
              show: false,
            },
          };
    }
    case OPEN_CLOSE_FILE: {
      return {
        ...state,
        file: {
          show: action.status,
          data: action.info,
        },
      };
    }
    case FIRE_COMMAND: {
      let dir = Object.entries(desktop_directories);
      var op = '';
      let history = state.terminal.history;
      var current_dir = state.terminal.current;
      if (action.cmd.fire) {
        history.push(state.terminal.prompt);
        switch (action.cmd.command) {
          case commands_list.list:
            op =
              state.terminal.current === '/'
                ? JSON.stringify(dir.map((dr) => dr[1].name))
                : Array.isArray(
                    dir.map((dr) => dr[1])[
                      dir
                        .map((dr) => dr[1].name)
                        .indexOf(state.terminal.current)
                    ].data
                  )
                ? JSON.stringify(
                    dir
                      .map((dr) => dr[1])
                      [
                        dir
                          .map((dr) => dr[1].name)
                          .indexOf(state.terminal.current)
                      ].data.map((file) => `${file.name}.${file.type}`)
                  )
                : 'This Directory does not contain files!';
            break;
          case commands_list.date:
            op = new Date().toUTCString();
            break;
          case commands_list.ls_cmd:
            op = JSON.stringify(commands_list);
            break;
          case commands_list.exit:
            op = 'Bye, terminal ended!';
            break;
          case commands_list.js_eval:
            let evalText = prompt('Enter the eval text: ');
            var soln;
            try {
              soln = eval(evalText);
            } catch (err) {
              soln = err;
            }
            op = evalText + '\n' + JSON.stringify(soln);
            break;
          case commands_list.history:
            op = JSON.stringify(history);
            break;
          case commands_list.history_clear:
            history = [];
            op = 'history was cleared!';
            break;
          default:
            if (state.terminal.prompt.split(' ')[0] === commands_list.echo) {
              op = state.terminal.prompt.split(' ')[1];
            } else if (
              state.terminal.prompt.split(' ')[0] === commands_list.cd &&
              dir
                .map((dr) => dr[1].name)
                .includes(state.terminal.prompt.split(' ')[1]) &&
              state.terminal.current === '/'
            ) {
              current_dir = state.terminal.prompt.split(' ')[1];
              op = `Changed PWD to ${state.terminal.prompt.split(' ')[1]}`;
            } else if (
              state.terminal.prompt.split(' ')[0] === commands_list.cd &&
              (state.terminal.prompt.split(' ')[1] === '..' ||
                state.terminal.prompt.split(' ')[1] === '/')
            ) {
              current_dir = '/';
              op = `Changed PWD to /`;
            } else if (
              state.terminal.prompt.split(' ')[0] === commands_list.cd
            ) {
              op = 'Please ensure correct file/dir name';
            } else {
              op = `Welcome Yash Datir, Please enter a correct command...`;
            }
        }
      }
      return {
        ...state,
        menu: {
          ...state.menu,
          terminal: state.terminal.prompt === 'exit' ? false : true,
        },
        terminal: {
          ...state.terminal,
          command:
            state.terminal.prompt === commands_list.clear
              ? `[use:> ${commands_list.ls_cmd}] for command list`
              : action.cmd.fire
              ? state.terminal.command + '\n>' + action.cmd.command + '\n' + op
              : state.terminal.command,
          prompt: action.cmd.prompt,
          current: current_dir,
          history,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export const rootReducer = combineReducers({
  pages: pageReducer,
  login: loginReducer,
});
